import React from "react";
import InfoCircle from "./InfoCircle";

const sizeClasses = {
  xs: "w-fit min-w-5 h-5 text-[8px]",
  "xs-sm": "w-fit min-w-6 h-6 text-[10px]",
  sm: "w-fit min-w-7 h-7 text-xs",
  md: "w-fit min-w-8 h-8 text-sm",
  lg: "w-fit min-w-9 h-9 text-sm",
  xl: "w-fit min-w-12 h-12 text-base",
  xxl: "w-fit min-w-[52px] h-[52px] text-lg",
  "3xl": "w-fit min-w-[64px] h-[64px] text-2xl",
  "4xl": "w-fit min-w-[80px] h-[80px] text-4xl",
  "5xl": "w-fit min-w-[120px] h-[120px] text-5xl",
};

const borderClasses = {
  xs: "border-[1px]",
  "xs-sm": "border-[1px]",
  sm: "border-[1px]",
  md: "border-[1px]",
  lg: "border-[2px]",
  xl: "border-[2px]",
  xxl: "border-[2px]",
  "3xl": "border-[2px]",
  "4xl": "border-[2px]",
  "5xl": "border-[2px]",
};

const InfoCardWithCircle = ({
  data,
  size = "md",
  color = "gray",
  colorDepth = "200",
  variant = "contained",
  noBorder = false,
  className = "",
}) => {
  //if numberValue >99 px will be change based on the size

  const paddingClasses = {
    xs: "px-0.5 py-1",
    "xs-sm": "px-0.5 py-1",
    sm: "px-0.5 py-0.5",
    md: "px-0.5 py-1",
    lg: "px-1 py-1",
    xl: "px-1 py-1",
    xxl: "px-1 py-1",
    "3xl": "px-2 py-1",
    "4xl": "px-2 py-1",
    "5xl": "px-2 py-1",
  };
  const getNextColorDepth = (currentDepth) => {
    const depths = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
    const currentIndex = depths.indexOf(Number(currentDepth));

    if (currentIndex === -1) return "500"; // fallback

    // If 900 or 800, return 900
    if (["800", "900"].includes(String(currentDepth))) {
      return "900";
    }

    // Jump two steps ahead, clamp to last index (900)
    const nextIndex = Math.min(currentIndex + 2, depths.length - 1);
    return String(depths[nextIndex]);
  };

  const getTextColor = (depth) => {
    return Number(depth) < 400 ? "black" : "white";
  };

  const updateColorDepth = (variant, colorDepth) => {
    return variant === "outlined" ? "50" : colorDepth;
  };

  const updatedColorDepth = updateColorDepth(variant, colorDepth);
  const borderColorDepth = noBorder
    ? colorDepth
    : getNextColorDepth(colorDepth);

  const formatValue = (val) => {
    const num = Number(val);
    if (num === 0) return "0";
    if (num >= 1 && num <= 9) return `0${num}`;
    return val;
  };

  return (
    <div
      className={`px-6 py-4 flex gap-2 rounded ${borderClasses[size]} 
      ${
        variant === "outlined"
          ? `border-${color}-${colorDepth}`
          : `border-${color}-${borderColorDepth}`
      }
      leading-none ${sizeClasses[size]} ${className} ${
        variant === "contained"
          ? `bg-${color}-${updatedColorDepth}/10 text-${getTextColor(
              updatedColorDepth
            )}`
          : `text-${color}-${colorDepth} bg-transparent`
      } ${noBorder ? "border-transparent" : ""}`}
    >
      <div className="flex gap-8">
        {Object.entries(data[0]).map(([key, value]) => {
          return (
            <div className="flex items-center gap-2" key={key}>
              <p className="text-sm font-[500]">{key}</p>
              <InfoCircle value={formatValue(value)} noBorder size={"xs-sm"} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoCardWithCircle;
